import { useState } from "react";
import "../Styles/signUp.css";
import logo from "../asset/Image/logo.png";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoBlack from "../asset/Image/logo1.png";
import { BiArrowBack } from "react-icons/bi";
import api from "../util/axios";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sign, setSign] = useState({
    email: "",
  });

  const handleChange = ({ target: { name, value } }: any) => {
    setSign({ ...sign, [name]: value });
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .post(
        "/auth/password/reset/business",
        {
          email: sign.email,
        }
      )
      .then((res) => {
        toast.success("Mail sent. Check your inbox!");
        setLoading(false);
        setTimeout(() => {
          navigate("/reset-password", { state: { email: sign.email } });
        }, 3000)
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <div className="auth">
      <ToastContainer />
      <div className="left">
        <div>
          <img src={logo} alt="" />

          <div className="leftCon1">
            <h2>Forgot Password</h2>
            <p>Regain access to your account by entering your email</p>
            <form onSubmit={handleSubmit}>
              <div className="input1">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="example@email.com"
                  name="email"
                  required
                  value={sign.email}
                  onChange={handleChange}
                />
              </div>
              <div className="flex w-full gap-2 mt-16">
                <button onClick={(() => navigate(-1))} className="bg-white text-black flex gap-1 justify-center items-center"><span><BiArrowBack /></span>Back</button>
                <button type="submit" className="bg-blue-600 text-white">
                  {loading ? (
                    <CircularProgress
                      style={{ color: "#fff", width: "25px", height: "25px" }}
                    />
                  ) : (
                    "Continue"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="right">
        <div className="rightCon">
          <h4>Oneflare Business Suite</h4>
          <h2>
            <h2>
              You don't <span>Remember?</span>  Don’t worry we got you{" "}
              <span>covered.</span>
            </h2>
          </h2>
        </div>

        <img src={logoBlack} alt="" className="logoBottom" />
      </div>
    </div>
  );
};

export default ForgotPassword;
